module.exports = __webpack_public_path__ + "static/media/ptelogo.99b6b828.png";